



<div id="customizable-dashboard1" *ngIf="!userDashboard">
 

    <div class="row px-4 mt-3">
        <div class="col-12 pr-1">

            <!--Welcome Section Shimmer-->
            <div class="card border h-100 rounded-0">
                <div class="row pl-5">
                    <div class="col-md-6 pl-7">
                        <div class="row mt-4 font-weight-bolder">
                            Welcome Back,
                        </div>
                        <div *ngIf="!isLoaded && isEmpty" class="row mt-4">
                            <ngx-shimmer-loading [width]="'150px'" [height]="'25px'"></ngx-shimmer-loading>

                        </div>

                        <div class="row">

                            <span class="userDate h6">
                                <!-- <img src="assets/common/images/Activities/dashboardcloud.png" height="20" /> -->

                                <span *ngIf="!isLoaded && isEmpty" class="h6 mt-2">
                                    <ngx-shimmer-loading [width]="'100px'" [height]="'15px'"></ngx-shimmer-loading>

                                </span>

                            </span>

                        </div>

                        <div class="row pt-9 pb-3">
                            <div class="col-md-6 col-lg-4 pl-0">
                                <ngx-shimmer-loading [width]="'100%'" [height]="'100%'"></ngx-shimmer-loading>
                            </div>
                            <div class="col-md-6 col-lg-4 pl-0">
                                <div class="row">
                                    <ngx-shimmer-loading [width]="'100%'" [height]="'100%'"></ngx-shimmer-loading>
                                </div>
                                <div class="row">
                                    <ngx-shimmer-loading [width]="'100%'" [height]="'100%'"></ngx-shimmer-loading>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div class="col-md-6 mt-3">
                        <!-- <ngx-shimmer-loading [width]="'100%'" [height]="'100%'"></ngx-shimmer-loading> -->
                        <div class="font-weight-bolder">
                            <span class="pr-1">
                                <img id="profimgsize" class="imageAlign border border-light rounded h-25px w-25px"
                                     src="/assets/common/images/photos/Dashboard_CurrentProject.svg">
                            </span>
                           

                            <!-- <img id="profimgsize" class="imageAlign border border-light rounded h-25px w-25px"
        src="/assets/common/images/photos/Dashboard_ProjectCount.png"> -->
                        </div>

                        <div class="mt-2">
                            <ngx-shimmer-loading [width]="'30px'" [height]="'30px'"></ngx-shimmer-loading>

                        </div>

                        <div class="d-flex justify-content-between">
                            <div class="mt-2">
                                <ngx-shimmer-loading [width]="'200px'" [height]="'30px'"></ngx-shimmer-loading>
                            </div>
                            <div class="mt-2 pr-2">
                                <ngx-shimmer-loading [width]="'200px'" [height]="'30px'"></ngx-shimmer-loading>
                            </div>

                        </div>
                    </div>
                </div>

                <div class="row mb-4 px-8 ">

                    <div *ngIf="!isLoaded && isEmpty" class="col-md-6  p-0">
                        <span class="label h-50px w-310px mr-3 label-inline bg-secondary-o-20 justify-content-start">
                            <div class="d-flex">
                                <div class="d-flex align-items-center cursor-pointer">
                                    <ngx-shimmer-loading [width]="'100%'" [height]="'100%'"></ngx-shimmer-loading>

                                </div>
                                <!-- <div class="d-flex flex-column cursor-pointer ml-3">

                                    <ngx-shimmer-loading [width]="'80px'" [height]="'10px'"></ngx-shimmer-loading>

                                </div>
                                <div class="d-flex align-items-center cursor-pointer ml-5">
                                    <div class="d-flex justify-content-center align-items-end mb-1 rounded w-70">

                                        <ngx-shimmer-loading [width]="'20px'" [height]="'20px'"></ngx-shimmer-loading>


                                    </div>
                                </div>
                                <div class="d-flex flex-column cursor-pointer ml-3">
                                    <ngx-shimmer-loading [width]="'80px'" [height]="'10px'"></ngx-shimmer-loading>

                                </div> -->


                            </div>
                        </span>
                    </div>
                </div>
            </div>

            <div id="timecards" class="row top_card_section h-100 pt-2">
                <div class="col-md-6 col-lg-3 pb-0 pl-0 pr-0 mt-0 p-2" *ngFor="let item of  leavesCards; let i = index">
                    <div class="card shadow-sm card-stretch rounded-0 p-0" style="height:87px">
                     
                        <div>
                            <div class="row pl-3 mt-8">
                                <div class="col-4">
                                    <div class="row">
                                        <div class="col-12">
                                            <div class="card rounded-0">
                                                <ngx-shimmer-loading [width]="'40px'" [height]="'40px'"></ngx-shimmer-loading>

                                            </div>

                                        </div>

                                    </div>
                                </div>
                                <div class="col-8">
                                    <div class="row mt-1 no-gutters">
                                        <div class="col-12">
                                            <div class="card border border-0 rounded-0">
                                                <ngx-shimmer-loading [width]="'90px'" [height]="'15px'"></ngx-shimmer-loading>

                                            </div>

                                        </div>

                                        <div class="col-12">
                                            <div class="card rounded-0">
                                                <ngx-shimmer-loading [width]="'90px'" [height]="'15px'"></ngx-shimmer-loading>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                     </div>
                    </div>
                </div>
            </div>




        <div class="col-12 py-1">
            <div class="card h-300px rounded-0 mb-3">
                <div class="row px-3 pt-4 ">

                    <div class="col-md-11">
                        <div class="row px-4">
                            <div>
                                <img src="../../../../assets/common/images/Activities/dashboardCalendar.svg" class="h-20px w-20px" />

                            </div>
                            <div class="font-weight-bolder h6 text-left ml-3">
                               {{'ProductivityBar' | localize}}
                            </div>
                        </div>


                    </div>
                </div>

                <div class="row mt-6">
                    <div class="col-12 py-10 px-10">
                        <ngx-shimmer-loading [width]="'100%'" [height]="'300px'"></ngx-shimmer-loading>
                    </div>

                </div>


            </div>
        </div>
    </div>






</div>
<div id="customizable-dashboard" class="dashboard-info" *ngIf="userDashboard">

    <div id="dashboard-tabs" style="overflow-x: hidden !important; overflow-y:auto !important">
        <!--<tabset #dashboardTabs [justified]="true" [ngClass]="{'nav-hidden': !moreThanOnePage()}" style="height: initial !important; ">
        <tab *ngFor="let page of (userDashboard?.pages || []); let i = index" heading="{{page.name}}"
             (selectTab)="selectPageTab(page.id)" class="700px">
            <gridster [options]="options[i]"
                      [perfectScrollbar]="{wheelPropagation: false}" style="height: initial !important; ">
                <gridster-item *ngFor="let widget of page.widgets" [item]="widget.gridInformation" style="padding: 0px;">
                    <ng-container *ngComponentOutlet="widget.component"></ng-container>
                    <button class="btn btn-sm text-white bg-danger deleteWidgetButton"
                            *ngIf="editModeEnabled" (click)="removeItem(widget.gridInformation)">
                        <i class="fa fa-times"></i>
                    </button>
                </gridster-item>
            </gridster>
        </tab>
    </tabset>-->
        <!--<tabset #dashboardTabs [justified]="true" [ngClass]="{'nav-hidden': !moreThanOnePage()}">
        <tab *ngFor="let page of (userDashboard?.pages || []); let i = index" heading="{{page.name}}" class="ml-1 test1"
             (selectTab)="selectPageTab(page.id)">
          <gridster *ngIf="dashboardTabs.tabs[i].active || !firstDashboardVisit" [options]="options[i]"
                      [perfectScrollbar]="{wheelPropagation: false}" style="height: initial !important;">
                <gridster-item *ngFor="let widget of page.widgets" [item]="widget.gridInformation">
                    <ng-container *ngComponentOutlet="widget.component"></ng-container>


                    <button class="btn btn-sm text-white bg-danger deleteWidgetButton"
                            *ngIf="editModeEnabled" (click)="removeItem(widget.gridInformation)">
                        <i class="fa fa-times"></i>
                    </button>
                </gridster-item>
            </gridster>
        </tab>
    </tabset>-->
       
        <div *ngIf="dashboardTab == 1" class="">
            <div *ngIf="userDashboard?.pages[0]" class="row">
                <gridster [options]="options[0]"
                          [perfectScrollbar]="{wheelPropagation: false}">
                    <gridster-item *ngFor="let widget of userDashboard?.pages[0].widgets" [item]="widget.gridInformation">
                        <ng-container *ngComponentOutlet="widget.component"></ng-container>


                        <button class="btn btn-sm text-white bg-danger deleteWidgetButton"
                                *ngIf="editModeEnabled" (click)="removeItem(widget.gridInformation)">
                            <i class="fa fa-times"></i>
                        </button>
                    </gridster-item>
                </gridster>
                <div class="col-md-12">

                </div>
            </div>
        </div>

        <div *ngIf="dashboardTab == 2">
            <div *ngIf="userDashboard?.pages[1]">
                <gridster [options]="options[1]"
                          [perfectScrollbar]="{wheelPropagation: false}">
                    <gridster-item *ngFor="let widget of userDashboard?.pages[1].widgets" [item]="widget.gridInformation">
                        <ng-container *ngComponentOutlet="widget.component"></ng-container>


                        <button class="btn btn-sm text-white bg-danger deleteWidgetButton"
                                *ngIf="editModeEnabled" (click)="removeItem(widget.gridInformation)">
                            <i class="fa fa-times"></i>
                        </button>
                    </gridster-item>
                </gridster>
            </div>
        </div>

    </div>



    <p-sidebar id="application-sidebar" [(visible)]="isSidebarOpen" [blockScroll]="true" position="right" styleClass="p-sidebar-md p-sidebar-bottom"
               class="d-none" appendTo="body">

    </p-sidebar>

</div>



